<template>
    <form @submit.prevent="submitSelectCourier">
        <div class="select-courier-pickup-box">
            <div class="courier-box"  v-if="enableEmst">
                <input type="radio" id="emstPickup" value="EMST" v-model="selected">
                <label for="emstPickup">
                    <div class="courier-img">
                        <img src="../../../public/img/courier_icons/THP.png"/>
                    </div>
                </label>
            </div>

            <div class="courier-box" v-if="enableFlashExpress">
                <input type="radio" id="flePickup" value="FLE" v-model="selected">
                <label for="flePickup">
                    <div class="courier-img courier-fle-img">
                        <img src="../../../public/img/courier_icons/FLE.jpg" />
                    </div>
                </label>
            </div>
        </div>

        <div class="w-100 text-center mt-3">
            <b-button variant="secondary" @click="closeModalPickup">ยกเลิก</b-button>
            <b-button variant="success" type="submit">เลือก</b-button>
        </div>
    </form>
</template>

<script>
    export default {
        props: [
            'enableFlashExpress',
            'enableEmst'
        ],
        data() {
            return {
                selected: this.enableEmst ? 'EMST' : 'FLE'
            }
       },
       methods: {
        submitSelectCourier() {
            this.$emit('submit', this.selected)
        },
        closeModalPickup() {
            this.$emit('cancel')
        }
       }
    }
</script>